"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputCheckbox = require("@citrus/input-checkbox");
var PctyQuestionBuilderEditKnockout = function PctyQuestionBuilderEditKnockout(_ref) {
  var bannerText = _ref.bannerText,
    inputText = _ref.inputText,
    onChangeKnockout = _ref.onChangeKnockout,
    selected = _ref.selected;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("p", null, bannerText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row-float-fill pcty-flex",
    style: {
      paddingBottom: '12px',
      paddingTop: '12px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-fluid pcty-padding-right"
  }, /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
    automationId: "edit-question-knockout",
    id: "edit-question-knockout",
    onChange: onChangeKnockout,
    selected: selected
  }, inputText))))));
};
PctyQuestionBuilderEditKnockout.propTypes = {
  bannerText: _propTypes.default.string,
  inputText: _propTypes.default.string,
  onChangeKnockout: _propTypes.default.func.isRequired,
  selected: _propTypes.default.bool.isRequired
};
PctyQuestionBuilderEditKnockout.defaultProps = {
  bannerText: 'If your question is set to knockout mode, an incorrect response is considered an automatic fail. Knockout questions must be answered correctly to continue.',
  inputText: 'This is a knockout question.'
};
var _default = exports.default = PctyQuestionBuilderEditKnockout;